import { z } from "zod";

export const adminCurrencyFormSchema = z.object({
  currencyCode: z
    .string()
    .min(3, { message: "Currency code must be at least 3 characters" }),
  displayName: z
    .string()
    .min(3, { message: "Display name must be at least 3 characters" }),
});

export type adminCurrencyFormValues = z.infer<typeof adminCurrencyFormSchema>;
